(function () {
  function initVariantSizeSliders(root) {
    root = root || document;

    var sliders = root.querySelectorAll('[data-vs-slider]');
    if (!sliders.length) return;

    sliders.forEach(function (slider) {
      if (slider.dataset.vsInitialized === 'true') return;
      slider.dataset.vsInitialized = 'true';

      var card = slider.closest('[data-product-card]');
      var track = slider.querySelector('.vs-track');
      var prev = slider.querySelector('.vs-arrow--prev');
      var next = slider.querySelector('.vs-arrow--next');

      /* ==== Scroll con flechas ==== */
      function scrollTrack(direction) {
        if (!track) return;
        var scrollAmount = 80;
        track.scrollLeft += direction * scrollAmount;
      }

      if (prev) {
        prev.addEventListener('click', function (e) {
          e.preventDefault();
          scrollTrack(-1);
        });
      }

      if (next) {
        next.addEventListener('click', function (e) {
          e.preventDefault();
          scrollTrack(1);
        });
      }

      /* ==== Click/touch en tallas (delegado) ==== */
      slider.addEventListener('click', function (event) {
        var pill = event.target.closest('.vs-pill');
        if (!pill) return;

        event.preventDefault();
        event.stopPropagation();

        var variantId = pill.getAttribute('data-vt-variant-id');
        if (!variantId) return;

        // Si NO hay card → fallback: ir a la PDP (comportamiento clásico)
        if (!card) {
          var directUrl = pill.getAttribute('data-vt-variant-url');
          if (directUrl) window.location.href = directUrl;
          return;
        }

        // === MODO CARD (AJAX, sin navegar) ===
        var pills = slider.querySelectorAll('.vs-pill');
        pills.forEach(function (p) {
          p.classList.remove('vs-pill--active');
        });
        pill.classList.add('vs-pill--active');

        card.dataset.selectedVariantId = variantId;

        // Input hidden del ATC
        var variantInput = card.querySelector('[data-product-variant-input]');
        if (variantInput) {
          variantInput.value = variantId;
        }

        // Enlaces al producto → ?variant=ID
        var productUrl = card.getAttribute('data-product-url') || '';
        if (productUrl) {
          var variantUrl = productUrl + '?variant=' + encodeURIComponent(variantId);
          var links = card.querySelectorAll('[data-product-link]');
          links.forEach(function (link) {
            link.setAttribute('href', variantUrl);
          });
        }

        // Imagen de la card
        var imageEl = card.querySelector('[data-product-image]');
        if (imageEl) {
          var imgUrl = pill.getAttribute('data-vt-image');
          if (imgUrl) {
            imageEl.setAttribute('src', imgUrl);
          }
        }

        // Precio de la card
        var priceEl = card.querySelector('[data-product-price]');
        var price = pill.getAttribute('data-vt-price');
        var compareAt = pill.getAttribute('data-vt-compare-at-price');

        if (
          priceEl &&
          price &&
          window.Shopify &&
          typeof Shopify.formatMoney === 'function'
        ) {
          var moneyFormat =
            (window.theme && window.theme.moneyFormat) || '{{amount}}';

          var priceInt = parseInt(price, 10) || 0;
          var compareInt = compareAt ? parseInt(compareAt, 10) : 0;

          var formattedPrice = Shopify.formatMoney(priceInt, moneyFormat);
          var html =
            '<span class="price-item price-item--regular">' +
            formattedPrice +
            '</span>';

          if (compareInt > priceInt) {
            var formattedCompare = Shopify.formatMoney(compareInt, moneyFormat);
            html +=
              ' <span class="price-item price-item--compare">' +
              formattedCompare +
              '</span>';
          }

          priceEl.innerHTML = html;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initVariantSizeSliders(document);
    });
  } else {
    initVariantSizeSliders(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    initVariantSizeSliders(event.target);
  });
})();